const state = {
  isCollapsed: false
}

const mutations = {
  toggleCollapse(state) {
    state.isCollapsed = !state.isCollapsed
  },
  setCollapse(state, collapsed) {
    state.isCollapsed = collapsed
  }
}

const actions = {
  toggleCollapse({ commit }) {
    commit('toggleCollapse')
  },
  setCollapse({ commit }, collapsed) {
    commit('setCollapse', collapsed)
  }
}

const getters = {
  isCollapsed: state => state.isCollapsed
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}